(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dg-enriched-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dg-enriched-gallery')) {
    customElements.define('dg-enriched-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.panels = Array.from(this.querySelectorAll('.dg-enriched-stage > [data-gallery-panel]'));
        this.index = 0;
        const thumbnails = this.querySelector('[data-gallery-thumbnails]');
        this.buttons = this.panels.map((panel, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.galleryIndex = String(index);
          button.setAttribute('aria-label', `${index + 1}. ${panel.dataset.label}`);
          button.setAttribute('aria-pressed', String(index === 0));
          if (panel.dataset.thumbnail) {
            const image = document.createElement('img');
            image.src = panel.dataset.thumbnail;
            image.alt = '';
            image.loading = 'lazy';
            image.width = 180;
            image.height = 180;
            button.append(image);
          } else {
            const label = document.createElement('span');
            label.textContent = thumbnails.dataset.ingredientLabel;
            button.append(label);
          }
          thumbnails.append(button);
          return button;
        });
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.hasAttribute('data-gallery-index')) this.show(Number(button.dataset.galleryIndex));
          if (button.hasAttribute('data-gallery-next')) this.show(this.index + 1);
          if (button.hasAttribute('data-gallery-previous')) this.show(this.index - 1);
          if (button.hasAttribute('data-gallery-enlarge')) {
            const content = this.querySelector('[data-gallery-dialog-content]');
            const clone = this.panels[this.index].cloneNode(true);
            clone.hidden = false;
            clone.querySelectorAll('img').forEach(image => { image.loading = 'eager'; image.sizes = '95vw'; });
            content.replaceChildren(clone);
            this.querySelector('dialog').showModal();
          }
          if (button.hasAttribute('data-gallery-close')) this.querySelector('dialog').close();
        });
        thumbnails.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = this.index + (event.key === 'ArrowLeft' ? -1 : 1);
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.panels.length - 1;
          this.show(next);
          this.buttons[this.index].focus();
        });
        const stage = this.querySelector('.dg-enriched-stage');
        stage.addEventListener('pointerdown', event => { this.startX = event.clientX; this.startY = event.clientY; });
        stage.addEventListener('pointerup', event => {
          const deltaX = event.clientX - this.startX;
          const deltaY = event.clientY - this.startY;
          if (Math.abs(deltaX) > 55 && Math.abs(deltaX) > Math.abs(deltaY) * 1.5) this.show(this.index + (deltaX < 0 ? 1 : -1));
        });
      }
      show(index) {
        this.index = (index + this.panels.length) % this.panels.length;
        this.panels.forEach((panel, position) => { panel.hidden = position !== this.index; });
        this.buttons.forEach((button, position) => { button.setAttribute('aria-pressed', String(position === this.index)); });
        this.querySelector('[data-gallery-count]').value = `${this.index + 1} / ${this.panels.length}`;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dg-product-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dg-product-gallery')) {
    customElements.define('dg-product-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const image = this.querySelector('.dg-gallery-image');
        const options = [...this.querySelectorAll('.dg-gallery-option')];
        const dialog = this.querySelector('dialog');
        options.forEach((button,index) => {
          button.addEventListener('click', () => {
            image.src = button.dataset.gallerySrc;
            image.srcset = button.dataset.gallerySrcset;
            image.alt = button.dataset.galleryAlt;
            options.forEach(option => option.setAttribute('aria-pressed', String(option === button)));
          });
          button.addEventListener('keydown', event => {
            if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
            event.preventDefault();
            const next = options[(index + (event.key === 'ArrowRight' ? 1 : options.length - 1)) % options.length];
            next.focus(); next.click();
          });
        });
        this.querySelector('.dg-gallery-zoom').addEventListener('click', () => {
          const full = dialog.querySelector('img'); full.src = image.src; full.alt = image.alt; dialog.showModal();
        });
        this.querySelector('.dg-gallery-close').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dg-visible-mobile-nav"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dg-visible-navigation')) {
    customElements.define('dg-visible-navigation', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          this.querySelectorAll('details[open]').forEach(detail => {
            detail.open = false;
            detail.querySelector('summary').focus();
          });
        });
        document.addEventListener('click', event => {
          if (!this.contains(event.target)) this.querySelectorAll('details[open]').forEach(detail => detail.open = false);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
